<template>
  <div class="page-box">
    <!-- 开立 -->
    <div class="out_box">
      <div class="title">
        {{ isShow ? '祺信-数字债权凭证' : '祺信-数字债权凭证流转单' }}
      </div>
      <a-row class="top_info" type="flex" justify="space-around">
        <a-col :xxl="8" :xl="10" :lg="12">
          <p class="c13">
            <img src="@/assets/images/logoQX.png" alt="" style="padding-left: 5px;" width="32" />
            <span class="c63">凭证编号:</span>
            {{ goldData.gldId }}
          </p>
        </a-col>
        <a-col :xxl="6" :xl="5" :lg="12">
          <p class="c13" v-if="isShow">
            <span class="c63">开立日期:</span>
            {{ goldData.openTime }}
          </p>
          <p class="c13" v-else>
            <span class="c63">流转日期:</span>
            {{ goldData.wanderAboutTime }}
          </p>

        </a-col>
        <a-col :xxl="6" :xl="5" :lg="12">
          <p class="c13">
            <span class="c63">到期日期:</span>
            {{ goldData.exDayStr }}
          </p>
        </a-col>
        <a-col :xxl="4" :xl="4" :lg="12">
          <p class="c13" style="text-align:right;">
            <span class="c63">凭证状态:</span>
            {{ goldData.rcPty.isFund == '1' ? '已融资' : goldData.voucherStatus }}
          </p>
        </a-col>
      </a-row>
      <!-- 数字债权凭证 -->
      <table v-if="isShow" style="width: 100%; text-align: center" cellspacing="0" cellpadding="0">
        <tbody>
          <tr class="firstRow">
            <td valign="center" style="width: 10%;" rowspan="2" colspan="1" class="c63">
              开立方
              <br />
              （债务人）
            </td>
            <td valign="center" style="width: 15%;" class="c63">全称</td>
            <td valign="center" style="width: 25%" class="c13">
              {{ goldData.estb && goldData.estb.customerName }}
            </td>
            <td valign="center" style="width: 10%;" rowspan="4" colspan="1" class="c63">
              接收方
              <br />
              （债权人）
            </td>
            <td valign="center" style="width: 15%;" class="c63">全称</td>
            <td valign="center" style="width: 25%" class="c13">
              {{ goldData.rcPty && goldData.rcPty.customerName }}
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">统一社会信用代码</td>
            <td valign="center" class="c13">
              {{ goldData.estb && goldData.estb.orgCode }}
            </td>
            <td valign="center" class=" c63">统一社会信用代码</td>
            <td valign="center" class="c13">
              {{ goldData.rcPty && goldData.rcPty.orgCode }}
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2" colspan="1" class=" c63">
              担保方
              <br />
              （担保人）
            </td>
            <td valign="center" class=" c63">全称</td>
            <td valign="center" class="c13">{{ goldData.guarantorName || '-' }}</td>
            <td valign="center" class=" c63">开户银行</td>
            <td valign="center" class="c13">
              {{ goldData.rcPty && goldData.rcPty.accountName }}
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              统一社会信用代码
            </td>
            <td valign="center" class="c13">{{ goldData.guarantorOrgCode || '-' }}</td>
            <td valign="center" class=" c63">
              账号
            </td>
            <td valign="center" class="c13">
              {{ goldData.rcPty && goldData.rcPty.accountNo }}
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2" colspan="1" class=" c63">
              凭证信息
            </td>
            <td valign="center" class=" c63">
              流转金额
            </td>
            <td valign="center" class="c13 bgStripe">
              <span class="c63 amtLeft">
                人民币（大写）
              </span>
              <span class="c13 amtRight">
                {{ goldData.bigGldAmt }}
              </span>
            </td>
            <td valign="center" rowspan=" 1" colspan="3" class="c13" style="padding: 0;">
              <div class="key c63">
                <p>亿</p>
                <p>千万</p>
                <p>百万</p>
                <p>十万</p>
                <p>万</p>
                <p>千</p>
                <p>百</p>
                <p>十</p>
                <p>元</p>
                <p>角</p>
                <p>分</p>
              </div>
              <div class="value c13">
                <p v-for="(item, index) in goldData.gldAmountList" :key="index" class="c13">
                  {{ item }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              能否转让
            </td>
            <td valign="center" class=" c13">
              可转让
            </td>
            <td valign="center" class=" c63">
              能否融资
            </td>
            <td valign="center" rowspan="1" colspan="2" class=" c13">
              <span v-if="goldData.openType == 1">可融资</span><span v-else>不可融资</span><br />
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              交易资产包
            </td>
            <td valign="center" rowspan="1" colspan="2" class=" c13">
              <span v-if="goldData.openType == 1">合同/发票等 </span><span v-else>-</span>
            </td>
            <td valign="center" class=" c63">
              资产包HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.ZCBHash || '-' }}</td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              付款承诺函
            </td>
            <td valign="center" rowspan=" 1" colspan="2" class="c13">{{ goldData.paymentUndertakingNo || '-' }}</td>
            <td valign="center" class=" c63">
              承诺函HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.CNHHash || '-' }}</td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              担保协议书
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.guaranteeNo || '-' }}</td>
            <td valign="center" class=" c63">
              协议书HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.XYSHash || goldData.PZHash || '-' }}
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              开立方承诺信息
            </td>
            <td rowspan="1" colspan="5" class="c13">
              <p style="text-align: left; padding-left: 15px;padding-top:10px;">
                本凭证所列各项信息真实、无误、合法、合规、有效，债权债务已真实完整发生，对本凭证所列金额承诺到期无条件付款。
              </p>
              <p style="text-align: left;float:right;width:200px;">
                签署时间：{{ goldData.openSignTime || '-' }}
              </p>
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              接收方承诺信息
            </td>
            <td valign="center" rowspan="1" colspan="5" class=" c13">
              <p style="text-align: left; padding-left: 15px;padding-top:10px;">
                我司申明并承诺，对凭证所列债权无重复质押，转让或其他权利在先得情形。
              </p>
              <p style="text-align: left;float:right;width:200px;">
                签署时间：{{ goldData.signToacptDay || '-' }}
              </p>
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              担保方承诺信息
            </td>
            <td valign="center" rowspan="1" colspan="5" class=" c13">
              <p style="text-align: left; padding-left: 15px;padding-top:10px;">
                我司申明并承诺，对开立方未按期执行金额部分承担连带担保责任，并承担付款义务。
              </p>
              <p style="text-align: left;float:right;width:200px;">签署时间：{{ goldData.guaranteeSignDate || '-' }}</p>
            </td>
          </tr>
          <tr>
            <td valign="center" class=" c63">
              签署栏
            </td>
            <td valign="center" rowspan="1" colspan="5" class="c63" style="padding: 0;">
              <div class="sign">
                <div style="width: 33.33%;">
                  <p class="signTitle">开立方：</p>
                  <p style="text-align: right;">
                    开立经办：<span class="c13" style="margin-right: 10px;">{{ goldData.openHandle }}</span>
                    复核经办：<span class="c13">{{ goldData.openSignUser }}</span>
                  </p>
                  <div id="estb"></div>
                </div>
                <div style="width: 33.33%;">
                  <p class="signTitle">担保方：</p>
                  <p style="text-align: right;">
                    担保经办：<span class="c13">{{ goldData.guaranteeJingBan || '-' }}</span>
                  </p>
                  <div v-if="goldData.guaranteeStCd == '2'" id="danbao"></div>
                </div>
                <div style="width: 33.33%;border: none;">
                  <p class="signTitle">接收方：</p>
                  <p style="text-align: right;">
                    接收经办：<span class="c13">{{ goldData.receiverUser || '-' }}</span>
                  </p>
                  <div v-if="goldData.gldStCd == '1'" id="rcPty"></div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 凭证流转单 -->
      <table v-else style="width: 100%; text-align: center" cellspacing="0" cellpadding="0" data-sort="sortDisabled">
        <tbody>
          <tr class="firstRow">
            <td valign="center" style="width: 10%; word-break: break-all;" rowspan="2" colspan="1" class="c63">
              兑付方
            </td>
            <td valign="center" style="width: 15%;" class="c63">
              全称
            </td>
            <td valign="center" style="width: 25%" class="c13">
              {{ goldData.estb && goldData.estb.customerName }}
            </td>
            <td valign="center" style="width: 10%; word-break: break-all;" rowspan="2" colspan="1" class="c63"
              width="168">
              流转方
            </td>
            <td valign="center" style="width: 15%; word-break: break-all;" class="c63">
              全称
            </td>
            <td valign="center" style="width: 25%; word-break: break-all;" class="c13">
              {{ goldData.pypt && goldData.pypt.customerName }}
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              统一社会信用代码
            </td>
            <td valign="center" class="c13">
              {{ goldData.estb && goldData.estb.orgCode }}
            </td>
            <td valign="center" class="c63">
              统一社会信用代码
            </td>
            <td valign="center" class="c13">
              {{ goldData.pypt && goldData.pypt.orgCode }}
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2" colspan="1" class="c63">
              担保方
            </td>
            <td valign="center" class="c63">
              全称
            </td>
            <td valign="center" class="c13">{{ goldData.guarantorName || '-' }}</td>
            <td colspan="1" valign="center" align="null" style="width: 10%; word-break: break-all;" width="168"
              rowspan="2">
              接收方<br />
            </td>
            <td valign="center" class="c63">
              全称<br />
            </td>
            <td valign="center" class="c13">
              {{ goldData.rcPty && goldData.rcPty.customerName }}
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              统一社会信用代码
            </td>
            <td valign="center" class="c13">{{ goldData.guarantorOrgCode || '-' }}</td>
            <td valign="center" class="c63">
              统一社会信用代码
            </td>
            <td valign="center" class="c13">
              {{ goldData.rcPty && goldData.rcPty.orgCode }}
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2" colspan="1" class="c63">
              凭证信息
            </td>
            <td valign="center" class="c63">
              流转金额
            </td>
            <td valign="center" class="c13 bgStripe">
              <span class="c63 amtLeft">
                人民币（大写）
              </span>
              <span class="c13 amtRight"> {{ goldData.bigGldAmt }} </span>
            </td>
            <td valign="center" rowspan=" 1" colspan="3" class="c13" style="padding: 0;">
              <div class="key c63">
                <p>亿</p>
                <p>千万</p>
                <p>百万</p>
                <p>十万</p>
                <p>万</p>
                <p>千</p>
                <p>百</p>
                <p>十</p>
                <p>元</p>
                <p>角</p>
                <p>分</p>
              </div>
              <div class="value c13">
                <p v-for="(item, index) in goldData.gldAmountList" :key="index" :class="item == '￥' ? 'c63' : 'c13'">
                  {{ item }}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              能否转让
            </td>
            <td valign="center" class="c13">
              可转让
            </td>
            <td valign="center" class="c63">
              能否融资
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">
              <span v-if="goldData.openType == 1">可融资</span><span v-else>不可融资</span><br />
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              原始凭证信息
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.originalId }}</td>
            <td valign="center" class="c63">
              凭证HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.PZHash || '-' }}</td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              交易资产包
            </td>
            <td valign="center" rowspan=" 1" colspan="2" class="c13">
              <span v-if="goldData.openType == 1">合同/发票等 </span><span v-else>-</span>
            </td>
            <td valign="center" class="c63">
              资产包HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.ZCBHash || '-' }}</td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              转让协议
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.transferAgreementNo || '-' }}</td>
            <td valign="center" class="c63">
              协议HASH
            </td>
            <td valign="center" rowspan="1" colspan="2" class="c13">{{ goldData.XYSHash || goldData.PZHash || '-' }}
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              流转方承诺信息
            </td>
            <td rowspan="1" colspan="5" class="c13">
              <p style="text-align: left; padding-left: 15px;padding-top:10px;">
                本凭证所列各项信息真实、无误、合法、合规、有效，债权债务已真实完整发生。
              </p>
              <p style="text-align: left;float:right;width:200px;">
                签署时间：{{ goldData.wanderAboutSignTime || '-' }}
              </p>
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              接收方承诺信息
            </td>
            <td valign="center" rowspan="1" colspan="5" class="c13">
              <p style="text-align: left; padding-left: 15px;padding-top:10px;">
                我司申明并承诺，对凭证所列债权无重复质押，转让或其他权利在先得情形。
              </p>
              <p style="text-align: left;float:right;width:200px;">
                签署时间：{{ goldData.signToacptDay || '-' }}
              </p>
            </td>
          </tr>
          <tr>
            <td valign="center" class="c63">
              签署栏
            </td>
            <td valign="center" rowspan="1" colspan="5" class="c63" style="padding: 0;">
              <div class="sign">
                <div style="width: 50%;">
                  <p class="signTitle">流转方：</p>
                  <p style="text-align: right;">
                    开立经办：<span class="c13" style="margin-right: 10px;">{{ goldData.wanderAboutUser }}</span>
                    复核经办：<span class="c13">{{ goldData.wanderAboutCheckUser }}</span>
                  </p>
                  <div id="pypt"></div>
                </div>
                <div style="width: 50%;border: none;">
                  <p class="signTitle">接收方：</p>
                  <p style="text-align: right;">
                    接收经办：<span class="c13">{{ goldData.receiverUser || '-' }}</span>
                  </p>
                  <div v-if="goldData.gldStCd == '1'" id="rcPty"></div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="footer">
        <div class="item">
          <span>区块链存证证书二维码</span>
          <!-- <img class="img" height="80" width="80" src="@/assets/images/qrcode.png" /> -->
          <img class="img" height="80" width="80" :src="certificateURL" />
        </div>
        <div class="item">
          <span>电子签名证书颁发机构</span>
          <img class="img" height="60" src="@/assets/images/cfca.png" />
        </div>
        <div class="item">
          <span>数字债权凭证二维码</span>
          <img class="img" height="80" width="80" :src="voucherURL" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getBlockchainPicture } from '@/api/gold.js'
import QRCode from 'qrcode' //引入生成二维码插件

export default {
  name: 'pageDetailsBasic',
  props: {
    goldData: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      certificateURL: '',
      voucherURL: ''
    }
  },
  created() {
    console.log('goldData:', this.goldData)
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
      sessionData: "home/getSessionData",
    }),
    isShow() {
      return this.goldData.oriGldId === '0' || !this.goldData.gldId
    }
  },
  methods: {
    createSeal() {
      this.$nextTick(() => {
        console.log(this.goldData, 122321321131)
        if (this.goldData.oriGldId === '0' || !this.goldData.gldId) {
          this.goldData.estb &&
            this.utils.createSeal(
              document.getElementById('estb'),
              this.goldData.estb.customerName,
              '',
              150
            )
        } else {
          this.goldData.pypt &&
            this.utils.createSeal(
              document.getElementById('pypt'),
              this.goldData.pypt.customerName,
              '',
              150
            )
        }
        this.goldData.guaranteeJingBan &&
          this.utils.createSeal(
            document.getElementById('danbao'),
            this.goldData.guarantorName,
            '',
            150
          )
        this.goldData.rcPty &&
          this.utils.createSeal(
            document.getElementById('rcPty'),
            this.goldData.rcPty.customerName,
            '',
            150
          )
      })
    },
    getBlockchainPicture() {
      getBlockchainPicture({ gldId: this.goldData.gldId }).then(res => {
        this.createQRCode('left', res.description)
      })
    },
    createQRCode(type, urls) {
      let opts = {
        errorCorrectionLevel: "L", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 0, //二维码留白边距
        width: 80, //宽
        height: 80, //高
        text: "", //二维码内容
        color: {
          dark: "#000", //前景色
          light: "#fff", //背景色
        }
      }

      QRCode.toDataURL(urls, opts, (err, url) => {
        if (err) throw err;
        //将生成的二维码路径复制给data的QRImgUrl
        if (type == 'right') {
          this.voucherURL = url
        } else {
          this.certificateURL = url
        }
      })
    }
  },
  watch: {
    goldData: {
      deep: true,
      handler(val) {
        const tenantIds = this.sessionData.tenantIds.substring(1, this.sessionData.tenantIds.length - 1)
        this.createSeal()
        this.getBlockchainPicture()
        this.createQRCode('right', `${window.location.origin}/mobile/details/${this.goldData.gldId}/${this.isShow ? 'voucher' : 'circulation'}/${tenantIds}`)
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.title {
  font-size: 24px;
  font-family: "Microsoft YaHei";
  font-weight: 600;
  color: #333333;
  line-height: 33px;
  text-align: center;
}

.top_info {
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0 5px;
}

.top_info p {
  line-height: 25px;
}

.c13 {
  color: #333333;
  font-weight: 500;
  font-family: "Microsoft YaHei";
}

.c63 {
  color: #737F8E;
  font-family: "Microsoft YaHei";
}

.red {
  color: red;
}

.brn {
  border-right: 0;
  padding-right: 10px;
}

table {
  font-size: 16x;
  width: 100%;
  border-top: 1px solid #737F8E;
  border-left: 1px solid #737F8E;
  text-align: center;
}

td {
  border-right: 1px solid #737F8E;
  border-bottom: 1px solid #737F8E;
  padding: 2px 0;
}

.key,
.value {
  width: 100%;
  overflow: hidden;
}

.key {
  border-bottom: 1px solid #1d1d1d;
}

.key p,
.value p {
  padding: 3px 0;
  line-height: 30px;
  height: 35px;
  font-size: 16px;
  width: 9%;
  float: left;
  border-right: 1px solid #1d1d1d;
  box-sizing: border-box;
}

.key p:last-child,
.value p:last-child {
  border-right: 0px;
}

.value p {
  border-bottom: 0;
}

.text_box {
  text-align: left;
}

.text_box p:last-child {
  text-align: right;
  padding-right: 10em;
  margin-top: 1em;
}

.information {
  text-align: left;
  padding: 10px;
}

.footer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding: 10px 50px;
}

.footer .item {
  display: flex;
  align-items: center;
}

.footer .item span {
  display: inline-block;
  width: 110px;
  text-align: center;
  color: #028dca;
  vertical-align: middle;
  font-weight: 600;
  font-size: 18px;
}

.footer .item .img {
  vertical-align: middle;
  margin-left: 20px;
}

.sign {
  text-align: left;
  box-sizing: border-box;
  display: flex;
}

.sign>div {
  padding: 20px 30px 10px;
  border-right: 1px solid #737F8E;
  position: relative;
}

.sign>div>div {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.sign>div>.signTitle {
  padding: 30px 0;
}

.bgStripe {
  width: 25%;
  background: repeating-linear-gradient(to bottom,
      #eba4a4,
      #eba4a4 2px,
      transparent 1px,
      transparent 5px);
}

.amtLeft {
  display: inline-block;
  vertical-align: middle;
  color: #1d1d1d;
  width: 60px;
}

.amtRight {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  max-width: 70%;
}

.page-box {
  font-family: "Microsoft YaHei" !important;
  border: 30px solid gray;
  border-image: url('~@/assets/images/bgborder.png') 26 round;
  padding: 30px 20px 20px;
  background-image: url('~@/assets/images/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.out_box {
  padding: 0 15px;
  font-family: "Microsoft YaHei";
}

@page {
  size: A3 landscape;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-details-basic/index.vue